export default __webpack_public_path__ + "static/media/aereo.c7c65e21.glb";